import { createI18n } from "vue-i18n";
import en from "../src/languages/en.json";
import km from "../src/languages/kh.json";
import zh from "../src/languages/zh.json";

const messages = {
  en,
  km,
  zh,
};

// Get saved locale or fallback to 'en'
const savedLocale = localStorage.getItem("locale") || "en";

const i18n = createI18n({
  legacy: false, // required for Composition API
  locale: localStorage.getItem("locale") || "en",
  fallbackLocale: "en",
  messages,
});

export default i18n;
